var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "mb14 normal-page",
        },
        [
          _c("div", { staticClass: "flex-between mb14" }, [
            _c("div", { staticClass: "title" }, [_vm._v("检测工单")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.openCreate },
                  },
                  [_vm._v("开单")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", loading: _vm.migrating },
                    on: { click: _vm.runMigrate },
                  },
                  [_vm._v("迁移历史数据")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.getList } },
                  [_vm._v("刷新")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            { staticClass: "mb14", attrs: { inline: true, size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "单号" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.where.order_no,
                      callback: function ($$v) {
                        _vm.$set(_vm.where, "order_no", $$v)
                      },
                      expression: "where.order_no",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "车牌" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.where.plate_no,
                      callback: function ($$v) {
                        _vm.$set(_vm.where, "plate_no", $$v)
                      },
                      expression: "where.plate_no",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "来源" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { clearable: "", placeholder: "全部" },
                      model: {
                        value: _vm.where.source,
                        callback: function ($$v) {
                          _vm.$set(_vm.where, "source", $$v)
                        },
                        expression: "where.source",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "手工", value: "manual" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "迁移", value: "migrate" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getList } },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.list, border: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "70" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "order_no",
                  label: "工单号",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "plate_no", label: "车牌", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "vin",
                  label: "VIN",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "source", label: "来源", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.statusText(scope.row.status)))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "legacy_customer_id",
                  label: "旧客户ID",
                  width: "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updated_at",
                  label: "更新",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "220", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openReport(scope.row)
                              },
                            },
                          },
                          [_vm._v("报告")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openCatalog(scope.row)
                              },
                            },
                          },
                          [_vm._v("进度")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-fixed" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.where.limit,
                  "current-page": _vm.where.page,
                  total: _vm.total,
                  layout: "total, prev, pager, next",
                },
                on: {
                  "current-change": function (p) {
                    _vm.where.page = p
                    _vm.getList()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "开单", visible: _vm.createVisible, width: "480px" },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.createForm.template_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "template_id", $$v)
                        },
                        expression: "createForm.template_id",
                      },
                    },
                    _vm._l(_vm.templates, function (t) {
                      return _c("el-option", {
                        key: t.id,
                        attrs: {
                          label: t.name + " (" + t.code + ")",
                          value: t.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "车牌" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.createForm.plate_no,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "plate_no", $$v)
                      },
                      expression: "createForm.plate_no",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "VIN" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.createForm.vin,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "vin", $$v)
                      },
                      expression: "createForm.vin",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.createVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitCreate },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawerVisible,
            size: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c("pre", { staticClass: "json-pre" }, [
            _vm._v(_vm._s(_vm.drawerJson)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }